import { createProformaDTO, GetAllIVReimbursementDTO, GetAllIVReimbursementFiltersDTO, GetAllProformaFiltersDTO, GetAllProformaResponseDTO, IVReimbursementAssignmentEstimatedCostDTO, IVReimbursementDTO, ReimbursementTypeEnum, UpdateProformaDTO } from "./dto";
import { IVReimbursementServiceImpl } from "./serviceImpl";

export interface IVReimbursementService {
    CreateIVReimbursement(data: IVReimbursementDTO): Promise<void>
    UpdateIVReimbursement(data: IVReimbursementDTO, id: string): Promise<void>
    DeleteIVReimbursement(id: string): Promise<void>
    GetIVReimbursementAssignmentCostEstimates(assignmentId: string): Promise<IVReimbursementAssignmentEstimatedCostDTO>
    GetIVReimbursementByInspectorCodeAndType(inspectorCode: string, type: ReimbursementTypeEnum): Promise<IVReimbursementDTO>
    GetAllIVReimbursement(filters: GetAllIVReimbursementFiltersDTO): Promise<GetAllIVReimbursementDTO>
    GetIVReimbursementById(id: string): Promise<IVReimbursementDTO>
    GetAllProforma(filters: GetAllProformaFiltersDTO): Promise<GetAllProformaResponseDTO>
    UpdateProforma(data: UpdateProformaDTO, id: string): Promise<void>
    CreateProforma(data: createProformaDTO): Promise<void>
}

export function NewIVReimbursementService(): IVReimbursementService {
    return new IVReimbursementServiceImpl()
}